import Box from '@mui/material/Box'
import isEmpty from 'lodash-es/isEmpty'
import { useGlobalContext } from '../../../sharedComponents/src/Contexts/GlobalContext'
import { GroupNames } from '../../../sharedComponents/src/globalHeader/GlobalHeader'
import { useScreenSize } from '../../../sharedComponents/src/hooks/useScreenSize'
import CircularButton from '../../analysisView/components/analyisControls/CircularButton'
import FlipIcon from '../../gameView/components/gameEndControls/icons/Flip'
import { FtueOptions } from '../functions/puzzlesApi'
import HintIcon from '../icons/Hint'
import ShowDescriptionIcon from '../icons/ShowDescription'
import SolutionIcon from '../icons/Solution'
import TagIcon from '../icons/Tag'

interface IProps {
    showDescriptionButton: boolean
    disableByState: boolean
    isLastPuzzle: boolean
    showSolutionDisabled: boolean
    isInitialized: boolean
    welcomeDescOpen?: boolean
    disableTags?: boolean
    ftueOptions?: FtueOptions
    showBackdrop?: boolean
    availableHints: number
    showHintLimit?: boolean
    hintTooltipText?: string
    hintAnimated?: boolean
    onShowSolution: () => void
    onFlip: () => void
    onHint: () => void
    onTags?: () => void
    onShowDescription: () => void
}

const PuzzleControls: React.FC<IProps> = (props) => {
    const {
        showDescriptionButton,
        disableByState,
        isLastPuzzle,
        showSolutionDisabled,
        isInitialized,
        disableTags = false,
        ftueOptions,
        showBackdrop,
        hintAnimated = true,
        onShowSolution,
        onFlip,
        onHint,
        onTags,
        onShowDescription,
        welcomeDescOpen,
        availableHints,
        showHintLimit,
        hintTooltipText,
    } = props
    const { userType } = useGlobalContext()
    const { isMobile } = useScreenSize()

    const hintFtue = showBackdrop && ftueOptions?.highlightHint
    const hint2Ftue = showBackdrop && ftueOptions?.highlightSecondHint
    const hintDescription =
        userType === GroupNames.SUBSCRIBED && availableHints === 0
            ? 'Earn more from Daily Bonus'
            : hintTooltipText !== ''
              ? hintTooltipText
              : undefined
    const descriptionFtue = showBackdrop && ftueOptions?.highlightDescription && isMobile
    const descriptionText = descriptionFtue ? 'Tap here for puzzle description' : undefined

    return (
        <Box
            sx={{
                position: 'relative',
                display: 'flex',
                justifyContent: 'center',
                flexGrow: 0,
                gap: '24px',
            }}
        >
            <CircularButton
                onClick={onShowSolution}
                title="Solution"
                icon={<SolutionIcon />}
                disabled={
                    disableByState || isLastPuzzle || showSolutionDisabled || !isInitialized || !isEmpty(ftueOptions)
                }
            />

            <CircularButton onClick={onFlip} title="Flip" icon={<FlipIcon />} disabled={!isEmpty(ftueOptions)} />

            <CircularButton
                onClick={onHint}
                title="Hint"
                description={hintDescription}
                icon={<HintIcon />}
                badge={availableHints >= 0 ? availableHints : undefined}
                animated={isEmpty(ftueOptions) && hintAnimated}
                disabled={
                    disableByState ||
                    isLastPuzzle ||
                    showSolutionDisabled ||
                    !isInitialized ||
                    (!isEmpty(ftueOptions) && !(ftueOptions?.highlightHint || ftueOptions?.highlightSecondHint >= 0))
                }
                showTooltip={hintFtue || (typeof hint2Ftue === 'number' && hint2Ftue >= 0) || showHintLimit}
            />

            {onTags && (
                <CircularButton
                    onClick={onTags}
                    title="Themes"
                    icon={<TagIcon />}
                    disabled={isLastPuzzle || showSolutionDisabled || disableTags}
                />
            )}

            {showDescriptionButton && (
                <CircularButton
                    onClick={welcomeDescOpen ? () => {} : onShowDescription}
                    title="Description"
                    description={descriptionText}
                    icon={<ShowDescriptionIcon />}
                    disabled={isLastPuzzle || showSolutionDisabled}
                    showTooltip={descriptionFtue}
                />
            )}
        </Box>
    )
}

PuzzleControls.displayName = 'PuzzleControls'

export default PuzzleControls
